import { render, staticRenderFns } from "./ServiceProcessing.vue?vue&type=template&id=87c126a4&scoped=true&"
import script from "./ServiceProcessing.vue?vue&type=script&lang=js&"
export * from "./ServiceProcessing.vue?vue&type=script&lang=js&"
import style0 from "./ServiceProcessing.vue?vue&type=style&index=0&id=87c126a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c126a4",
  null
  
)

export default component.exports